// Validation quantité minimum par variante (metafields)
(function() {
  'use strict';

  let variantData = {};

  function loadVariantData() {
    const productJson = document.querySelector('[data-product-json]');
    if (productJson) {
      try {
        const product = JSON.parse(productJson.textContent);
        
        // Vérifier le metafield au niveau produit
        const productMinQty = product.metafields?.custom?.min_quantity;
        if (productMinQty) {
          product.variants.forEach(variant => {
            variantData[variant.id] = {
              minQuantity: parseInt(productMinQty),
              title: variant.title,
              source: 'product'
            };
          });
        }
        
        // Les metafields de variante ont la priorité
        product.variants.forEach(variant => {
          const variantMinQty = variant.metafields?.custom?.min_quantity;
          
          if (variantMinQty) {
            variantData[variant.id] = {
              minQuantity: parseInt(variantMinQty),
              title: variant.title,
              source: 'variant'
            };
          }
        });
      } catch (e) {
        // Erreur silencieuse
      }
    }
  }

  function getSelectedVariantId(form) {
    const variantInput = form.querySelector('input[name="id"]') || 
                        form.querySelector('select[name="id"]');
    return variantInput ? variantInput.value : null;
  }

  function showError(message, form) {
    hideError();
    
    const errorDiv = document.createElement('div');
    errorDiv.className = 'quantity-min-error';
    errorDiv.style.cssText = `
      color: rgb(189, 8, 28);
      background: rgba(189, 8, 28, 0.1);
      border: 1px solid rgba(189, 8, 28, 0.3);
      padding: 0.75rem 1rem;
      margin-bottom: 1rem;
      border-radius: 0.25rem;
      font-size: 1rem;
      font-weight: 600;
      text-align: center;
      animation: slideIn 0.3s ease;
    `;
    errorDiv.textContent = message;
    
    if (!document.querySelector('#quantityErrorStyles')) {
      const style = document.createElement('style');
      style.id = 'quantityErrorStyles';
      style.textContent = `
        @keyframes slideIn {
          from { opacity: 0; transform: translateY(-10px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `;
      document.head.appendChild(style);
    }
    
    // Insérer AVANT le buy-buttons (au lieu d'après)
    const buyButtons = form.closest('.product-info')?.querySelector('.buy-buttons') || 
                      document.querySelector('buy-buttons[form="' + form.getAttribute('id') + '"]');
    
    if (buyButtons) {
      buyButtons.insertAdjacentElement('beforebegin', errorDiv);
    } else {
      form.insertAdjacentElement('beforebegin', errorDiv);
    }
  }

  function hideError() {
    const error = document.querySelector('.quantity-min-error');
    if (error) error.remove();
  }

  function validateMinQuantity(e, form) {
    if (!form) return true;

    // CORRECTION : Récupérer le vrai ID du formulaire
    const formId = form.getAttribute('id');
    
    // Chercher l'input quantité lié au formulaire (par attribut form)
    const quantityInput = document.querySelector(`input[name="quantity"][form="${formId}"]`) ||
                         form.querySelector('input[name="quantity"]');
    
    if (!quantityInput) {
      return true;
    }

    const variantId = getSelectedVariantId(form);
    if (!variantId) {
      return true;
    }

    const variant = variantData[variantId];
    if (!variant || !variant.minQuantity) {
      hideError();
      return true;
    }

    const currentQuantity = parseInt(quantityInput.value) || 1;

    if (currentQuantity < variant.minQuantity) {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      
      showError(
        `Quantité minimum pour ce produit : ${variant.minQuantity} article${variant.minQuantity > 1 ? 's' : ''}.`,
        form
      );
      
      quantityInput.focus();
      return false;
    }

    hideError();
    return true;
  }

  // Initialiser
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadVariantData);
  } else {
    loadVariantData();
  }

  // IMPORTANT : Écouter sur le buy-buttons element ET sur submit
  document.addEventListener('click', function(e) {
    // Chercher le bouton dans buy-buttons
    const button = e.target.closest('buy-buttons button[type="submit"]');
    if (button) {
      const formId = button.closest('buy-buttons')?.getAttribute('form');
      const form = formId ? document.getElementById(formId) : null;
      
      if (form && form.matches('form[action*="/cart/add"]')) {
        validateMinQuantity(e, form);
      }
    }
  }, true);

  // Backup : écouter aussi sur submit
  document.addEventListener('submit', function(e) {
    if (e.target.matches('form[action*="/cart/add"]')) {
      validateMinQuantity(e, e.target);
    }
  }, true);

  // Cacher erreur au changement de quantité
  document.addEventListener('input', function(e) {
    if (e.target.matches('input[name="quantity"]')) {
      hideError();
    }
  });

  // Cacher erreur au changement de variante
  document.addEventListener('change', function(e) {
    if (e.target.matches('input[name="id"], select[name="id"]')) {
      hideError();
    }
  });

})();